
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const VIPeel = () => {
  const treatmentData = {
    title: "VI Peel",
    subtitle: "Professional chemical peel for smoother, brighter skin",
    description: "The VI Peel is a medical-grade chemical peel that improves skin tone, texture, and clarity with minimal downtime. Perfect for addressing fine lines, acne, and hyperpigmentation.",
    whoItsFor: [
      "Those with sun damage or age spots",
      "People dealing with acne or acne scars",
      "Anyone wanting smoother skin texture",
      "Clients with fine lines and wrinkles",
      "Those seeking overall skin rejuvenation"
    ],
    packages: [
      {
        name: "VI Peel Original",
        visitorPrice: "$350",
        memberPrice: "$315",
        description: "Classic peel for overall skin improvement"
      },
      {
        name: "VI Peel Precision Plus",
        visitorPrice: "$450",
        memberPrice: "$405",
        description: "Advanced peel for hyperpigmentation"
      },
      {
        name: "Peel Series",
        visitorPrice: "$950",
        memberPrice: "$855",
        description: "Package of 3 peels for maximum results"
      }
    ],
    beforeCare: [
      "Discontinue retinoids 1 week prior",
      "Avoid waxing 1 week before",
      "Use SPF 30+ for 2 weeks prior",
      "No recent sun exposure or tanning"
    ],
    duringCare: [
      "Thorough skin cleansing",
      "Precise peel application",
      "30-45 minute treatment time",
      "Detailed aftercare instructions provided"
    ],
    afterCare: [
      "Do not wash face for 4 hours",
      "Gentle cleansing with provided products",
      "Expect peeling days 3-7",
      "Strict sun protection required"
    ],
    memberPerks: [
      "10% discount on all VI Peel treatments",
      "Complimentary post-peel skincare kit",
      "Free follow-up consultation",
      "Priority scheduling for series treatments",
      "Access to professional-grade aftercare products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default VIPeel;
